// extracted by mini-css-extract-plugin
export default {"container":"ProjectHelpPage5_container__Ojm7I","text":"ProjectHelpPage5_text__Iv1ut","imageExampleActions":"ProjectHelpPage5_imageExampleActions__60WHs"};